module.exports = __webpack_public_path__ + "img/93.f27429f8.jpg";